import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title mb-2"
}
const _hoisted_2 = { class: "font-medium text-lg" }
const _hoisted_3 = { class: "text-sm" }

import type { Student } from "@/api/models/types";
import ArrowFrontIcon from "@/assets/icons/arrow-front.svg";
import type {
  GroupedChallengeMatching,
  GroupedJobPostingMatching,
} from "@/models/CompanyDashboard";


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyMatchGroup',
  props: {
    matches: {}
  },
  setup(__props: any) {



const getStudentName = (student: Student) =>
  student.firstName ? `${student.firstName} ${student.lastName}` : student.nickname;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.matches, (match, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass(["link-list__item mb-4", [{ 'link-list__item--job': 'jobPosting' in match }]])
      }, [
        ('jobPosting' in match)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(match.jobPosting.displayTitle), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(match.challenge.displayTitle), 1),
              _createElementVNode("h4", _hoisted_3, _toDisplayString(match.challenge.challengeType.name), 1)
            ], 64)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(match.students, (student) => {
            return (_openBlock(), _createElementBlock("li", {
              key: student.id,
              class: "link-list__item font-medium"
            }, [
              ('jobPosting' in match)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
              name: 'StudentDetail',
              params: { slug: student.slug },
              query: { jobPostingId: match.jobPosting.id },
            },
                    class: "hover:text-primary-1 transition-colors underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getStudentName(student)) + " ", 1),
                      _createVNode(_unref(ArrowFrontIcon), { class: "xl:w-5 w-8 mr-2 xl:mr-1 mb-1 shrink-0 inline-block" })
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : ('challenge' in match)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: {
              name: 'StudentDetail',
              params: { slug: student.slug },
              query: { challengeId: match.challenge.id },
            },
                      class: "hover:text-primary-1 transition-colors underline font-medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStudentName(student)) + " ", 1),
                        _createVNode(_unref(ArrowFrontIcon), { class: "xl:w-5 w-8 mr-2 xl:mr-1 mb-1 shrink-0 inline-block" })
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ], 2))
    }), 128))
  ]))
}
}

})